import useCurrentUser from '~/hooks/useCurrentUser'
import { useGetUserSettingsQuery, useSetUserSettingsMutation } from '~/redux/apis/user-settings-api'

interface UseUserSettingsResult {
  data: ReturnType<typeof useGetUserSettingsQuery>['data']
  isTooltipNotLoaded: boolean
  hideLearningPathTooltip?: boolean | undefined
  hideVideoUnderstoodTooltip?: boolean | undefined
  setHideLearningPathTooltip: (hide: boolean) => void
  setHideVideoUnderstoodTooltip: (hide: boolean) => void
}

export const useUserSettings = (): UseUserSettingsResult => {
  const user = useCurrentUser()
  const { data, isFetching, isLoading, isUninitialized } = useGetUserSettingsQuery(undefined, { skip: !user })
  const isTooltipNotLoaded = isFetching || isLoading || isUninitialized
  const hideLearningPathTooltip = data?.tipsTooltip?.hideLearningPathTooltip
  const hideVideoUnderstoodTooltip = data?.tipsTooltip?.hideVideoUnderstoodTooltip

  const [setHideTooltipMutation] = useSetUserSettingsMutation()

  const setHideLearningPathTooltip = (hide: boolean): void => {
    setHideTooltipMutation({
      tipsTooltip: {
        ...data?.tipsTooltip,
        hideLearningPathTooltip: hide,
      },
    })
  }

  const setHideVideoUnderstoodTooltip = (hide: boolean): void => {
    setHideTooltipMutation({
      tipsTooltip: {
        ...data?.tipsTooltip,
        hideVideoUnderstoodTooltip: hide,
      },
    })
  }

  return {
    data,
    isTooltipNotLoaded,
    hideLearningPathTooltip,
    hideVideoUnderstoodTooltip,
    setHideLearningPathTooltip,
    setHideVideoUnderstoodTooltip,
  }
}
